
import React from "react";
import Loading from "../../Loading";
import { i18nManager } from "../../../i18n";
import { FormStep, Utils } from "../../../utils";
import { Status } from "../../../constants/Status";
import { CardProcessor, ITransaction, PloutousService } from "../../../services";
import InterswitchCard from "./InterswitchCard";
import PloutousCard from "./PloutousCard";

export interface CardProps {
    businessId: string;
    transaction: ITransaction;
    paymentSuccessful: () => void;
    loadingState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
    fetchTransaction: (onDone?: (result?: ITransaction, error?: any) => void) => void;
}

let action: any;
let otpNextStep: any;
function Card(props: CardProps) {

    const transaction = props.transaction;
    const labels = i18nManager.Labels.method.card;
    const ploutousService = PloutousService.getInstance();
    const serviceErrorsState = React.useState<string[]>([]);
    const [chargeData, setChargeData] = React.useState<any>({});
    const stepState = React.useState<FormStep>(FormStep.ENTER_CARD_DETAIL);
    const [serviceWarnings, setServiceWarnings] = React.useState<string[]>([]);
    const [serviceSuccesses, setServiceSuccesses] = React.useState<string[]>([]);
    const [serviceErrors, setServiceErrors] = serviceErrorsState;
    const [step, setStep] = stepState;

    React.useEffect(loadRawApis, []);
    React.useEffect(() => {
        if (step !== FormStep.CONFIRM_PAYMENT) return;
        confirmPayment();
    }, [step]);

    if (serviceSuccesses.length) {
        return Utils.buildPaymentCompletedView(transaction, serviceSuccesses);
    }

    if (serviceWarnings.length) {
        return Utils.buildPartialPaymentView(transaction, serviceWarnings, () => {
            setServiceWarnings([]);
            setStep(FormStep.ENTER_CARD_DETAIL);
        }, () => {
            setServiceWarnings([]);
            setStep(FormStep.CONFIRM_PAYMENT);
        });
    }

    if (serviceErrors.length) {
        return Utils.buildPaymentErrorView(transaction, serviceErrors, () => {
            setServiceErrors([]);
            setStep(FormStep.ENTER_CARD_DETAIL);
        });
    }

    return (<div className="credit-card">
        {step === "CONFIRM_PAYMENT" && (<>
            <Loading label={i18nManager.Labels.common.confirming_payment} />
        </>)}
        {(step !== "CONFIRM_PAYMENT" && transaction.card_processor === CardProcessor.SIM) && (<PloutousCard {...props} stepState={stepState} serviceErrorsState={serviceErrorsState} setActions={(pay, genOtp) => {
            action = pay;
            otpNextStep = genOtp;
        }} />)}
        {(step !== "CONFIRM_PAYMENT" && transaction.card_processor === CardProcessor.EPI) && (<InterswitchCard {...props} stepState={stepState} setActions={(pay, genOtp) => {
            action = pay;
            otpNextStep = genOtp;
        }} />)}
    </div>);

    async function confirmPayment(requires3ds?: boolean) {
        props.fetchTransaction((result?: ITransaction, error?: any) => {
            if (error) {
                setServiceErrors(error.errors ?? [error.message]);
                return;
            }
            if (!(requires3ds ?? chargeData.result?.requires_3ds) && (result?.status ?? 0) === Status.TRANSACTION_PARTIALLY_PAID) {
                setServiceWarnings([i18nManager.Labels.common.partially_paid]);
                return;
            } else if ((result?.status ?? 0) > Status.TRANSACTION_FULLY_PAID_PENDING_ACKNOWLEDGEMENT) {
                props.paymentSuccessful();
                setServiceSuccesses([i18nManager.Labels.common.thank_you, i18nManager.Labels.common.payment_successful]);
                return;
            }
            setTimeout(() => confirmPayment(), 2000);
            console.log("Initiate web socket connection to track payment completion");
            // TODO in the API service implements logic to fetch every 2 seconds 5 times from processor once a verify transaction is received
            // also for double webhook log it to be able to detect duplicate payments from processor
        });
    }

    // RAW WINDOW API
    function loadRawApis() {
        if (window.addEventListener) {
            window.addEventListener("message", onMessage, false);
        } else if ((window as any).attachEvent) {
            (window as any).attachEvent("onmessage", onMessage, false);
        }

        function onMessage(event: any) {
            // Check sender origin to be trusted
            const data = event.data;
            if (/*event.origin !== ploutousService.baseUrl || */data.operation != "card_payment") return;
            console.log("We are here", (window as any).__pc_payload, step, data.payload);
            if (data.payload.status === "CANCELLED") {
                setServiceErrors([i18nManager.Labels.common.cancelled]);
                return;
            } else if (data.payload.status === "SERVER_ERROR") {
                setServiceErrors([labels.server_error]);
                return;
            } else if (data.payload.status === "UNKNOWN_ERROR") {
                setServiceErrors([labels.unknown_error]);
                return;
            } else if (data.payload.status === "CARD_EXPIRED") {
                setServiceErrors([labels.card_expired_error]);
                return;
            } else if (data.payload.status === "INSUFFICIENT_FUND") {
                setServiceErrors([labels.insufficient_funds_error]);
                return;
            }
            if (!(window as any).__pc_payload?.step) {
                confirmPayment(true);
                return;
            }
            otpNextStep?.();
        }
    }
    // END RAW WINDOW API

}

export default Card;
